<div class="collapsible"
  [class.over]="overlay" [class.open]="open"

  [@openState]="openState">

  <ng-content></ng-content>

</div>
@if (overlay && openState === 'open') {
  <div class="overlay-blue fadein-quick">
  </div>
}
